var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5513_16729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7852C0.059827 11.5964 0.570581 9.54204 1.60841 7.62797C1.72608 7.41077 1.96836 7.21242 2.19876 7.11821C2.47812 7.00416 2.76292 7.13457 2.9508 7.39143C3.1471 7.65921 3.12633 7.94086 3.00321 8.23888C2.66205 9.06352 2.24969 9.86932 2.01236 10.7237C0.237825 17.114 4.22052 23.6948 10.7036 25.0034C14.7011 25.8102 18.1938 24.6964 21.1402 21.8695C21.2178 21.7951 21.2895 21.7148 21.3666 21.6404C21.6702 21.3473 22.0272 21.2833 22.3397 21.4643C22.6443 21.6409 22.7876 21.9686 22.6799 22.3643C22.2591 23.9065 21.8334 25.4472 21.3894 26.9829C21.2242 27.5547 20.6497 27.7257 20.1617 27.3583C19.5426 26.8917 18.9375 26.4067 18.3362 25.9173C18.1686 25.7809 18.0302 25.7606 17.8255 25.8424C10.3253 28.8499 1.94363 24.3216 0.323362 16.3757C0.149815 15.5257 0.104821 14.6495 0 13.7852Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 13.7862C26.0042 15.3611 25.717 16.879 25.1741 18.3487C24.9457 18.9671 24.2831 19.1337 23.8708 18.6844C23.5963 18.3854 23.6507 18.0522 23.7768 17.711C24.2747 16.3623 24.4937 14.9669 24.471 13.5298C24.3889 8.33109 20.651 3.70013 15.5874 2.59532C11.8693 1.78407 8.52737 2.62656 5.5914 5.05833C5.29424 5.30478 4.98967 5.46048 4.61587 5.27007C4.22625 5.07122 4.16791 4.72659 4.21785 4.32394C4.3647 3.1383 4.49869 1.95168 4.63219 0.764556C4.67174 0.410502 4.83144 0.153639 5.17508 0.0385965C5.51377 -0.0744628 5.77928 0.0747952 6.01117 0.305377C6.49374 0.785382 6.98027 1.26142 7.449 1.75432C7.5998 1.9125 7.71847 1.91201 7.90932 1.83614C12.6698 -0.0571073 17.136 0.48885 21.1578 3.67633C24.3776 6.22859 25.9172 9.68037 25.9998 13.7862Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5513_16729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27.5522,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarRing);
export default __webpack_public_path__ + "static/media/avatarRing.98b68bc09142d24634b7d50e97092f1a.svg";
export { ForwardRef as ReactComponent };